import type { ReactNode } from "react";

interface PageHeroProps {
  eyebrow: string;
  title: ReactNode;
  subtitle?: string;
  image?: string;
  children?: ReactNode;
}

const DEFAULT_IMAGE =
  "https://readdy.ai/api/search-image?query=Stunning%20aerial%20view%20of%20luxury%20A-frame%20wooden%20villas%20nestled%20in%20a%20lush%20green%20mountain%20valley%20at%20golden%20sunrise%2C%20modular%20wooden%20cabins%20with%20large%20triangular%20glass%20windows%2C%20surrounded%20by%20pine%20forest%20and%20mist%2C%20warm%20golden%20and%20green%20tones%2C%20premium%20hospitality%20real%20estate%20photography%2C%20high%20detail&width=1600&height=720&seq=public-hero-villa-default&orientation=landscape&nocache=true";

export default function PageHero({ eyebrow, title, subtitle, image, children }: PageHeroProps) {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="relative h-[420px] md:h-[520px] w-full">
        <img
          src={image || DEFAULT_IMAGE}
          alt={eyebrow}
          className="absolute inset-0 w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/55"></div>
        <div className="relative w-full h-full flex items-center justify-center">
          <div className="w-full px-4 md:px-8 max-w-5xl mx-auto text-center">
            <span className="inline-flex items-center gap-2 text-xs md:text-sm font-semibold tracking-[0.25em] uppercase text-accent-300">
              <i className="ri-sparkling-2-line"></i> {eyebrow}
            </span>
            <h1 className="font-heading text-3xl md:text-5xl text-background-50 mt-4 leading-tight">
              {title}
            </h1>
            {subtitle && (
              <p className="text-background-100/90 text-sm md:text-lg mt-5 max-w-2xl mx-auto leading-relaxed">
                {subtitle}
              </p>
            )}
            {children && <div className="mt-7">{children}</div>}
          </div>
        </div>
      </div>
    </section>
  );
}